<template>
  <v-dialog
        v-model="dialog"
        persistent
        content-class="elevation-0 text-xs-center"
      >
        <div id="loader-spinner">
          <v-fade-transition leave-absolute>
            <v-progress-circular  indeterminate :size="70" :width="7" color="accent"></v-progress-circular>
          </v-fade-transition>
        </div>
      </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialog: false
    }
  },
  created () {
    this.$store.watch((state) => state.loader.loader.loading, () => {
      const { loading } = this.$store.state.loader.loader
      this.dialog = loading
    })
  }
}
</script>

<style>
#loader-spinner {
  overflow: hidden
}
</style>
